/* eslint-disable */
// 文件查看右边弹出 柜桶
import React from 'react'
import WrappedDrawer from '@/components/WrappedDrawer'
import FormData from './NursingAlertsForm'

class NursingAlertsDrawer extends React.Component {
  render () {
    const { title, children, baseProps } = this.props
    return (
      <WrappedDrawer
        children={children}
        title={title}
        baseProps={baseProps}
        baseComponent={<FormData/>}
        width={800}
        footer={null}
        maskClosable={true}
      />
    )
  }
}
export default NursingAlertsDrawer
